import { MutationUpdaterFn } from "@apollo/client";

import {
  CreateLikeMutation,
  LikeDocument,
  LikeQueryVariables,
  RemoveLikeMutation,
} from "@/generated/generated-hooks";

type UpdateAfterLikePostArgs = {
  postId: string;
  variables: LikeQueryVariables;
};

export const updateAfterLike: (
  args: UpdateAfterLikePostArgs,
) => MutationUpdaterFn<CreateLikeMutation> =
  ({ postId, variables }) =>
  (cache, { data: { createLike } }) => {
    cache.modify({
      id: cache.identify({ __typename: "Post", _id: postId }),
      fields: {
        likes(existingLikes) {
          return existingLikes + 1;
        },
      },
    });

    cache.modify({
      id: cache.identify({ __typename: "Post", _id: postId }),
      fields: {
        hasCurrentUserLike() {
          return true;
        },
      },
    });

    /* TODO: review and maybe able to deprecate the following writeQuery in the future */
    cache.writeQuery({
      query: LikeDocument,
      data: { like: createLike },
      variables,
    });
    return;
  };
export const updateAfterUnlike: (
  args: UpdateAfterLikePostArgs,
) => MutationUpdaterFn<RemoveLikeMutation> =
  ({ postId, variables }) =>
  (cache) => {
    cache.modify({
      id: cache.identify({ __typename: "Post", _id: postId }),
      fields: {
        likes(existingLikes) {
          return existingLikes - 1;
        },
      },
    });
    cache.modify({
      id: cache.identify({ __typename: "Post", _id: postId }),
      fields: {
        hasCurrentUserLike() {
          return false;
        },
      },
    });
    cache.writeQuery({
      query: LikeDocument,
      data: { like: null },
      variables,
    });
    return;
  };
